import React, { useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import ParentRow from './ParentRow';

const ParentTable = ({ rows, visibleCols, allColumns, laydownList, current, aliasName }) => {
  const [openRowIndex, setOpenRowIndex] = useState(null);
  const [data, setData] = useState({});
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleToggle = (index) => {
    if (isRefreshing) return;
    
    setOpenRowIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box>
      <TableContainer component={Paper} sx={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto' }}>
        <Table stickyHeader sx={{ tableLayout: 'fixed', width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ bgcolor: 'primary.main', color: 'white', fontWeight: 600, width: 50 }}
              />
              {allColumns.map(
                (col) =>
                  visibleCols.includes(col.key) && (
                    <TableCell
                      key={col.key}
                      sx={{
                        bgcolor: 'primary.main',
                        color: 'white',
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        ...(col.key === 'description' ? { width: '30%' } : { width: 120 }),
                      }}
                    >
                      {col.label}
                    </TableCell>
                  )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row, idx) => (
              <ParentRow
                key={idx}
                row={row}
                visibleCols={visibleCols}
                allColumns={allColumns}
                isOpen={openRowIndex === idx}
                onToggle={() => handleToggle(idx)}
                data={data}
                setData={setData}
                laydownList={laydownList}
                current={current}
                setIsRefreshing={setIsRefreshing}
                aliasName={aliasName}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ParentTable;